





























































































































































import Vue from 'vue'
import axios from 'axios'
import SubmitFlow from '../organisms/SubmitFlow.vue'

export type DataType = {
  childName: string[],
  telItem: string[],
  email: string,
  confirmEmail: string,
  errors: any, // {変数名: エラーメッセージ}
  isLoading: boolean,
}
export default Vue.extend({
  components: {
    SubmitFlow
  },
  data(): DataType {
    return {
      childName: ['', ''],
      telItem: ['', '', ''],
      email: '',
      confirmEmail: '',
      errors: {},
      isLoading: false,
    }
  },
  computed: {
    questionPageUrl(): string {
      return `/tensaku_visiter/faq`
    },
    hasError(): boolean {
      return Object.keys(this.errors).length > 0
    },
    telNo(): string {
      return this.telItem.join('-')
    },
    isOverPeriod(): boolean {
      if (!process.env.VUE_APP_REGIST_PERIOD_TO) {
        return false
      }
      return new Date(process.env.VUE_APP_REGIST_PERIOD_TO) < new Date()
    }
  },
  methods: {
    validate(name: string, errorMessage: string, errorConditionFunc: () => boolean) {
      if (this.errors[name]) {
        return
      }
      if (errorConditionFunc()) {
        this.errors[name] = errorMessage
      }
    },
    validateAll(): boolean {
      this.errors = {}
      this.validate("childName1", '入力してください。', () => !this.childName[0])
      this.validate("childName2", '入力してください。', () => !this.childName[1])
      this.validate("telItem", '入力してください。', () => this.telItem.some(x => !x))
      this.validate("telItem", '半角数字で入力してください。', () => /[^0-9]/.test(this.telItem.join('')))
      this.validate("email", '入力してください。', () => !this.email)
      this.validate("confirmEmail", '入力してください。', () => !this.confirmEmail)
      this.validate("confirmEmail", 'メールアドレスと確認用メールアドレスが一致しません。', () => this.email !== this.confirmEmail)
      this.validate("email", 'メールアドレス形式で入力してください。', () => !/^[a-zA-Z0-9-_.+?/]+@([a-zA-Z0-9][a-zA-Z0-9-_.]*\.)+[a-zA-Z]{2,}$/.test(this.email))
      return !this.hasError
    },
    async regist() {
      try {
        this.isLoading = true
        if (this.validateAll()) {
          const res = await axios.post('/api/v1/preuser_regist', {
            email: this.email,
            child_name: this.childName.join('　'),
            phone: this.telNo
          })
          if (res.data.exist == "user") {
            this.errors = {}
            this.validate("childName", res.data.message, () => true)
            window.scrollTo({ top: 500, behavior: "smooth" })
          } else {
            this.$router.push('/tensaku_visiter/regist_result')
          }
        } else {
          window.scrollTo({ top: 500, behavior: "smooth" })
        }
      } finally {
        this.isLoading = false
      }
    }
  }
})
